
import React, { ChangeEvent, Dispatch } from "react";
import { useDispatch } from "react-redux";
import { setDialogHandle } from "../../../actions/dialog";
import Filters from '../Filters';
import Styles from "../../../scss/orderHistory.module.scss";
import { OrderListFilterIcon } from "./OrderListFilterIcon";
import { IOrderListSearchState, OrderListSearch } from "./OrderListSearch";
import { IFilterState } from "./state/OrderList.reducer";
import { setSearchState, setSearchTerm } from "./state/OrderList.action";
import { OrderListFinishAllButton } from "./OrderListFinishAllButton";
import { IProcessedOrders } from "../constants";


interface IOrderListActionProps {
    mainKey: string;
    selectedSearchState: IOrderListSearchState;
    dispatch: Dispatch<any>;
    selectedFilterCount: number;
    isLoading: boolean;
    filterState: IFilterState;
    venueId: string;
    canFinishAll?: boolean;
    canSearchItems?: boolean;
    orderList: IProcessedOrders[];
    refreshOrderList?: () => void;
    applyFilters: (orderTypes: Record<string, boolean>, areas: Record<string, boolean>, filtersCount: number, filtersChanged: boolean) => void;
}

export function OrderListActionBar({
    selectedSearchState,
    isLoading,
    selectedFilterCount,
    dispatch,
    filterState,
    venueId,
    applyFilters,
    orderList,
    refreshOrderList,
    mainKey,
    canFinishAll = false,
    canSearchItems = true
}: IOrderListActionProps) {
    const dispatcher = useDispatch();

    function openFilterDialog() {
        dispatcher(setDialogHandle({
            Component: Filters,
            ComponentProps: {
                selectedFitersCount: selectedFilterCount,
                filterItems: filterState,
                tableAreas: filterState.tableAreas,
                venueId: venueId,
                onApplyFiltersAndSearch: applyFilters
            },
            isFormDialog: false,
            styles: { className: Styles.FiltersDialog },
            dialogTitle: undefined
        }));
    }
    function setSearchStateObject(searchState: IOrderListSearchState) {
        dispatch(setSearchState(searchState));
    }
    function onChangeSearchTerm(value: ChangeEvent<HTMLInputElement>) {
        dispatch(setSearchTerm(value.target.value.toLowerCase()));
    }
    return <div className={Styles.SearchBarContainer}>
        <div>
            {canSearchItems && <OrderListSearch selectedSearchState={selectedSearchState}
                setSearchState={setSearchStateObject}
                onSearchChange={onChangeSearchTerm} />}
            {canFinishAll && <OrderListFinishAllButton
                orderList={orderList}  disabled={orderList.length===0}/>}
            <OrderListFilterIcon key={`${mainKey}-filter-icon`} isLoading={isLoading} selectedFilterCount={selectedFilterCount}
                openFiltersDialog={openFilterDialog} />
        </div>

    </div>
}